/**
 * BoltPlanningInput — Individual planning question input
 *
 * Three input modes based on question.inputType:
 *   - select: Chip-based multiple choice (orange when selected)
 *   - date: Native date input styled for dark theme
 *   - text: Standard text input with placeholder
 */

import React from 'react';

export default function BoltPlanningInput({ id, question, value, onChange, disabled }) {
  const { options, inputType } = question;

  // Select: chip-based multiple choice
  if (inputType === 'select' && options?.length > 0) {
    const isLargeList = options.length > 8;

    return (
      <div
        id={id}
        role="group"
        className={`bolt-planning-input bolt-planning-input--select${isLargeList ? ' bolt-planning-input--select-scrollable' : ''}`}
      >
        {options.map((opt) => (
          <button
            key={opt}
            className={`bolt-planning-chip${value === opt ? ' bolt-planning-chip--selected' : ''}`}
            onClick={() => !disabled && onChange(opt)}
            disabled={disabled}
            type="button"
          >
            {opt}
          </button>
        ))}
      </div>
    );
  }

  // Date input
  if (inputType === 'date') {
    return (
      <input
        id={id}
        type="date"
        className="bolt-planning-input bolt-planning-input--date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    );
  }

  // Default: text input
  return (
    <input
      id={id}
      type="text"
      className="bolt-planning-input bolt-planning-input--text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Type your answer..."
      disabled={disabled}
    />
  );
}
